exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.calendar-icon {\n  font-size: 39px;\n  position: absolute;\n  margin-left: -22px;\n  z-index: 2;\n  color: #848383;\n}\n\n.time-picker {\n  height: 50px !important;\n  text-align: center;\n  font-size: 18px !important;\n  border: 1px solid #d8d5d2 !important;\n  border-radius: .1875rem;\n  background-color: #ffffff;\n  line-height: 3;\n  width: 250px;\n}\n\n.time-picker.mat-select-value {\n\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/component/shared/time-picker/time-picker.component.css
// module id = 959
// module chunks = 3